module.exports = __webpack_public_path__ + "img/211-aa5d58.png";